import React, { useContext, useMemo } from 'react';

type Value = {
  navigation2024: boolean;
};

const FeatureFlagContext = React.createContext<Value>({
  navigation2024: false,
});

export const FeatureFlagProvider: React.FC<
  React.PropsWithChildren<{ navigation2024: boolean }>
> = ({ children, navigation2024 }) => {
  const value = useMemo<Value>(() => ({ navigation2024 }), [navigation2024]);

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export function useFeatureFlag(): Value {
  return useContext(FeatureFlagContext);
}
